//region header
//--------------------------------------------------------------------------------------------------
//
//  Description: The page routing form.
//
//  Copyright:    © 2021 - 2025 Idox Software Limited.
//
//--------------------------------------------------------------------------------------------------
//
//  Modification History:
//
//  Version Date     Modifier             Issue# Description
//region Version 1.0.0.0
//    001            Sean Flook                  Initial Revision.
//    002   19.06.24 Sean Flook        IMANN-629 Changes to code so that current user is remembered and a 401 error displays the login dialog.
//endregion Version 1.0.0.0
//region Version 1.0.7.0
//    003   01.09.25 Sean Flook       IMANN-1812 Changes required to update React-Router-Dom to v6.
//    004   04.09.25 Sean Flook       IMANN-1812 Changes required to update React-Router-Dom to v7.
//    005   04.09.25 Sean Flook       IMANN-1812 Changes required to replace React-Router-Dom with React_Router v7.8.2.
//endregion Version 1.0.7.0
//
//--------------------------------------------------------------------------------------------------
//endregion header

//region imports

import React from "react";
import { createBrowserRouter, createRoutesFromElements, Route } from "react-router";

import UnknownErrorBoundary from "./UnknownErrorBoundary";
import HomePage from "./pages/HomePage";
import GazetteerPage from "./pages/GazetteerPage";
import StreetPage from "./pages/StreetPage";
import PropertyPage from "./pages/PropertyPage";
import UserAdminPage from "./pages/UserAdminPage";
import SettingsPage from "./pages/SettingsPage";
import App from "./App";

//endregion imports

export const HomeRoute = "/";
export const GazetteerRoute = "/gazetteer";
export const StreetRoute = "/street";
export const TaskRoute = "/task";
export const ReportRoute = "/report";
export const PropertyRoute = "/property";
export const UserAdminRoute = "/userAdmin";
export const AdminSettingsRoute = "/settings";

export const router = createBrowserRouter(
  createRoutesFromElements(
    <Route ErrorBoundary={UnknownErrorBoundary}>
      <Route path="/" Component={App}>
        <Route path={HomeRoute} Component={HomePage} />
        <Route path={GazetteerRoute} Component={GazetteerPage} />
        <Route path={`${StreetRoute}/:usrn`} Component={StreetPage} />
        <Route path={`${PropertyRoute}/:uprn`} Component={PropertyPage} />
        <Route path={UserAdminRoute} Component={UserAdminPage} />
        <Route path={AdminSettingsRoute} Component={SettingsPage} />
      </Route>
    </Route>
  )
);
